import { render, staticRenderFns } from "./ProjectHeatMapChart.vue?vue&type=template&id=28d97924"
import script from "./ProjectHeatMapChart.vue?vue&type=script&lang=ts"
export * from "./ProjectHeatMapChart.vue?vue&type=script&lang=ts"
import style0 from "./ProjectHeatMapChart.vue?vue&type=style&index=0&id=28d97924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports